console.log("Breeze-Override Loaded");
checkoutUrl =
  window.location.protocol + "//" + window.location.hostname + "/checkout?";

window.addEventListener("breezeBroadcast", (event) => {
  const eventData = event.detail;
  window.cartData = eventData.value;
});

function clickNative() {
  const checkoutButton = document.getElementsByTagName(
    "shopify-buy-it-now-button"
  )[0];
  // console.log(">>> product-button", checkoutButton);
  checkoutButton.button.click();
}

function clickProductNative() {
  const productButton = document.getElementsByClassName(
    "shopify-payment-button__button"
  )[0];
  console.log(">>> product-button", productButton);
  productButton.click();
}

async function getCountry() {
  console.log(">>>getCountry");
  return window
    .fetch("https://api.country.is")
    .then((response) => response.json())
    .then((result) => {
      if (typeof result === "object" && typeof result.country === "string") {
        return result;
      } else {
        console.log("Unable to fetch location");
      }
    })
    .catch((error) => {
      console.error("Failed fetching IP location", error);
    });
}

async function onProductPage(props) {
  try {
    if (typeof props.country === "string" && props.country !== "IN") {
      // await clickNative();
      await clickProductNative();
      return false;
    }
    return true;
  } catch (e) {
    console.error("Breeze| Exception| onProductPage: ", e);
  }
  return true;
}

window.breeze = {
  onCheckoutButtonClick: async (props) => {
    console.log(">>>props", props);
    let location = await getCountry();
    console.log(">>>location", location);
    try {
      if (typeof location !== "undefined") {
        if (props !== null) {
          const res = await onProductPage(location);
          return res;
        } else {
          if (
            typeof location.country === "string" &&
            location.country !== "IN"
          ) {
            window.location.href = checkoutUrl;
            return false;
          } else {
            return true;
          }
        }
      } else {
        return true;
      }
    } catch (e) {
      console.error("Breeze| Exception| onCart: ", e);
    }
    return true;
  },
};